/* Holiday spa-package W3 presentation only. Does not change prices, selections,
   cart grouping, or product option inputs. Each package keeps its own options. */
(() => {
  'use strict';
  const profiles = {
    'cardamom-amber-restore-ritual': {
      title: 'Make the Ritual Even More Indulgent',
      items: [
        [/scalp massage/i, 'Extend the relaxation with gentle scalp work.'],
        [/sole revive/i, 'Reflexology-inspired care for tired feet.'],
        [/lunch for one|spa lunch|add lunch/i, 'Make this ritual a more leisurely spa escape.']
      ]
    },
    'yellow-creek-retreat': {
      title: 'Make It Their Ultimate Spa Day',
      items: [
        [/upgrade.*massage|90.min.*signature/i, 'More time to unwind and ease areas of tension.'],
        [/upgrade.*facial|essential facial/i, 'Enjoy a complete customized facial experience.'],
        [/sole revive/i, 'Extra pressure-focused care for tired feet.'],
        [/infrared sauna/i, 'Comforting warmth before spa treatments.'],
        [/lunch for one|spa lunch|add lunch/i, 'Enjoy a leisurely lunch between treatments.']
      ]
    },
    'cbd-lights-spa-package': {
      title: 'Extend the Feeling of Relaxation',
      items: [
        [/upgrade.*cbd|90.min.*cbd/i, 'More time for an immersive CBD massage.'],
        [/sole revive/i, 'Pressure-focused foot relaxation.'],
        [/recover touch.*facial/i, 'Complete the head-to-toe spa experience.'],
        [/infrared sauna/i, 'Enjoy an additional moment of infrared warmth.'],
        [/lunch for one|spa lunch|add lunch/i, 'Complete the spa escape with lunch.']
      ]
    },
    'prenatal-9-month-journey': {
      title: 'A Little Extra Care Along the Way',
      items: [
        [/eye zone lift/i, 'Targeted eye-area care during the facial, subject to provider approval.'],
        [/lunch for one|spa lunch|add lunch/i, 'Make one of the scheduled visits more leisurely.']
      ]
    },
    'mistletoe-massage-spa-package': {
      title:'A Little More Time to Unwind',
      items:[
        [/scalp massage/i,'Deeper, head-to-toe relaxation.'],
        [/sole revive/i,'Extra attention for tired feet.'],
        [/lunch for one|spa lunch|add lunch/i,'Make a little more of the day.']
      ]
    },
    'the-sugarplum-glow-spa-package': {
      title:'Take Their Glow Further',
      items:[
        [/eye zone lift/i,'Extra attention to the delicate eye area.'],
        [/jade stone|gua.sha/i,'Facial massage for a sculpted-looking glow.'],
        [/lunch for one|spa lunch|add lunch/i,'Make the experience even sweeter.']
      ]
    },
    'little-wonder-spa-package': {
      title:'A Little More Indulgence',
      items:[
        [/upgrade|50.min.*swedish/i,'More time for full-body relaxation.'],
        [/essential facial|upgrade.*facial/i,'More personalized skincare and pampering.'],
        [/paraffin.*hand/i,'Extra softness after the manicure.'],
        [/infrared sauna/i,'An added moment of warmth.'],
        [/lunch for one|spa lunch|add lunch/i,'Turn their escape into a spa day.']
      ]
    },
    'holly-spa-package': {
      title:'Make It Their Perfect Escape',
      items:[
        [/upgrade.*massage|90.min/i,'30 extra minutes of relaxation.'],
        [/sole revive/i,'Extra care for tired feet.'],
        [/recover touch.*facial/i,'Complete the head-to-toe pampering.'],
        [/infrared sauna/i,'Relax in soothing warmth.'],
        [/lunch for one|spa lunch|add lunch/i,'Make a day of it.']
      ]
    },
    'let-it-glow-spa-package': {
      title:'A Little Extra Glow',
      items:[
        [/upgrade.*massage|80.min/i,'More time to release tension.'],
        [/eye zone lift/i,'Refresh the delicate eye area.'],
        [/cbd balm/i,'Extra comfort for targeted areas.'],
        [/infrared sauna/i,'Warmth before the pampering begins.'],
        [/lunch for one|spa lunch|add lunch/i,'Extend the spa escape.']
      ]
    },
    'holiday-bliss-for-hands-and-feet': {
      title:'Even More Pampering',
      items:[
        [/paraffin.*hands?/i,'Extra softness for dry hands.'],
        [/paraffin.*feet|paraffin.*foot/i,'Extra conditioning for dry feet.'],
        [/recover touch.*facial/i,'Add a refreshing facial.'],
        [/infrared sauna/i,'A little warmth and relaxation.'],
        [/lunch for one|spa lunch|add lunch/i,'Make the visit more leisurely.']
      ]
    },
    'santa-baby-spa-package': {
      title:'A Little Extra Comfort for Mom',
      items:[
        [/anti.fatigue|fatigue.*leg/i,'Cooling comfort for tired, heavy-feeling legs.'],
        [/lunch for one|spa lunch|add lunch/i,'A little extra time for herself.']
      ]
    }
  };
  const handle = location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
  const profile = profiles[handle];
  if (!profile) return;
  const css = document.createElement('style');
  css.id = 'yc-holiday-w3-benefits-css';
  css.textContent = [
    '[data-yc-holiday-package] .yc-w3-choice-row.yc-holiday-w3-choice{display:grid;grid-template-columns:17px minmax(0,1fr);gap:0 10px;align-items:start}',
    '[data-yc-holiday-package] .yc-w3-choice-row.yc-holiday-w3-choice>input{grid-column:1;grid-row:1/3;margin-top:4px!important}',
    '[data-yc-holiday-package] .yc-w3-choice-row.yc-holiday-w3-choice>span:not(.yc-zen-w3-benefit){grid-column:2;grid-row:1}',
    '[data-yc-holiday-package] .yc-w3-choice-row>.yc-zen-w3-benefit{display:block;grid-column:2;grid-row:2;margin:2px 0 0;font:400 11px/1.4 "Figtree",Arial,sans-serif;color:#77726c}',
    '[data-yc-holiday-package] .yc-w3-options-shell .yc-zen-w3-title{margin:0 0 9px;font:600 11px/1.5 "Figtree",Arial,sans-serif;text-transform:uppercase;letter-spacing:.09em}'
  ].join('\n');
  document.head.append(css);
  let observer=null, current=null, frame=0;
  const normalize = s=>(s||'').replace(/\s+/g,' ').trim();
  function decorate(root){
    if(!root.classList.contains('loaded'))return;
    let matchCount=0;
    for(const row of root.querySelectorAll('.yc-w3-choice-row')){
      const rowText=normalize([...row.querySelectorAll('span,label')].filter(el=>!el.classList.contains('yc-zen-w3-benefit')).map(el=>el.textContent).join(' '));
      const item=profile.items.find(pair=>pair[0].test(rowText));
      if(!item)continue;
      matchCount++;
      row.classList.add('yc-holiday-w3-choice');
      let caption=row.querySelector(':scope > .yc-zen-w3-benefit');
      if(!caption){caption=document.createElement('span');caption.className='yc-zen-w3-benefit';row.append(caption);}
      if(caption.textContent!==item[1])caption.textContent=item[1];
    }
    if(!matchCount)return;
    const headings=[...root.querySelectorAll('.product-options-field-name-content')].map(x=>normalize(x.textContent));
    if(!headings.some(Boolean)&&!root.querySelector(':scope > .yc-zen-w3-title')){
      const heading=document.createElement('h3');
      heading.className='yc-zen-w3-title';
      heading.textContent=profile.title;
      root.prepend(heading);
    }
  }
  function tick(){if(frame)return;frame=requestAnimationFrame(()=>{frame=0;if(current?.isConnected)decorate(current);else attach();});}
  function attach(){
    const root=document.querySelector('[data-yc-holiday-package] .yc-w3-options-shell .w3-product-options');
    if(!root)return;
    if(root!==current){
      observer?.disconnect();
      current=root;
      observer=new MutationObserver(tick);
      observer.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
    }
    tick();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',attach,{once:true});else attach();
  document.addEventListener('shopify:section:load',attach);
  document.body.addEventListener('productOptionsLoadedJS',tick);
})();
